import { ViewModel,View, ObservableArray } from "binder"
import  { SelectorBaseView } from "./selectorBase-view"

export type ElementType = {
    set title(v: string);
    get title(): string;
    set id(v: string);
    get id(): string;
};

export abstract class SelectorBaseViewModel<T extends ElementType> extends ViewModel{
    constructor(parentViewModel: ViewModel,noRefresh?:boolean) {
        super(parentViewModel);
        
        if(noRefresh==null) noRefresh = false;
        this.items = ObservableArray.create<T>();
        this.isLoaded = false;
        if(noRefresh==false)
            this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new SelectorBaseView<T>();
    }
    public getTypeId(): string {
        return "VM-5DC0E83E-10B0-411D-9A44-4075ED01EEE5"
    }

    public set items(v: ObservableArray<T>) { this._items = v; } public get items(): ObservableArray<T> { return this._items;} private _items: ObservableArray<T>;
    public set selectedItem(v: T) { 
        this.selectedId = v?.id;
        if(this._selectedItem!=v){
            this._selectedItem = v;
            this.onSelectionChanged(v);
        }
    } public get selectedItem(): T { return this._selectedItem;} private _selectedItem: T;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private selectedId:string;
    private isLoaded:boolean;

    async refresh(){
        try {
            this.isLoading = true;
            let result =await this.loadData();
            this.isLoaded = true;
            this.updateItems(result);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public requestRefresh(){
        this.refresh();
    }
    updateItems(items:T[]){
        this.items.update(...items);
        this.isLoaded = true;
        if(this.selectedId!=null){
            this.selectById(this.selectedId);                
        }    
    }
    public selectById(id:string){
        if(id==null){
            this.selectedId = null;
            this.selectedItem = null;
        }else{
            this.selectedId = id;
            if(this.isLoaded==false)return;
            let filteredItem = this.items.filter(x=>x.id==id);
            if(filteredItem.length>0 ){
                if(this.selectedItem!=filteredItem[0]){
                    this.selectedItem = filteredItem[0];
                }
            }else{
                this.selectedItem = null;
            }
        }
    }
    protected abstract loadData():Promise<T[]>; 
    onSelectionChanged(element:T){};
}
